import React, { useState } from "react";
import ConfirmDialog from "./ConfirmDialog";
import FilterDialog from "./FilterDialog";

function SelectionBar({
  selectedCount,
  totalCount,
  onClear,
  onDelete,
  onSelectAll,
  allSelected,
  onApplyFilter,
  photos,
  selectedPhotos,
  onQuickOrder,
  onClearEdits,
  onClearSizes,
}) {
  const [showConfirm, setShowConfirm] = useState(false);
  const [showFilters, setShowFilters] = useState(false);
  const [showClearMenu, setShowClearMenu] = useState(false);

  // 🗑 Delete
  const handleDeleteClick = () => setShowConfirm(true);
  const handleConfirmDelete = () => {
    onDelete();
    onClear();
    setShowConfirm(false);
  };

  // 🎨 Filter
  const handleFilterClick = () => setShowFilters(true);
  const handleApplyFilter = (filter) => {
    onApplyFilter(filter);
    onClear();
    setShowFilters(false);
  };

  // ➕ Quick Order
  const handleQuickOrder = () => {
    onQuickOrder();
    onClear();
  };

  // 🧹 Clear options
  const handleClearEditsClick = () => {
    onClearEdits();
    onClear();
    setShowClearMenu(false);
  };

  

  const handleClearSizesClick = () => {
    onClearSizes();
    onClear();
    setShowClearMenu(false);
  };

  return (
    <>
      <header className="selection-bar">
        <span className="selected-count">{selectedCount} selected</span>

        <div className="selection-actions">
          <button className="action-btn" onClick={handleQuickOrder}>
            <i className="fa-solid fa-plus"></i> Add Sizes
          </button>
          <button className="action-btn" onClick={handleFilterClick}>
            <i className="fa-solid fa-sliders"></i> Edit Filters
          </button>

          {/* ✅ Unified Clear button with dropdown */}
          <div className="clear-dropdown">
            <button
              className="action-btn"
              onClick={() => setShowClearMenu(!showClearMenu)}
            >
              <i className="fa-solid fa-eraser"></i> Clear ▾
            </button>

            {showClearMenu && (
              <div className="clear-menu">
                <button onClick={handleClearEditsClick}>
                  <i className="fa-solid fa-pen"></i> Clear Edits
                </button>
                <button onClick={handleClearSizesClick}>
                  <i className="fa-solid fa-expand"></i> Clear Sizes
                </button>
              </div>
            )}
          </div>

          <button className="action-btn" onClick={handleDeleteClick}>
            <i className="fa-solid fa-trash-can"></i> Delete
          </button>
        </div>

        <div className="selection-right">
          <button
            className="toggle-btn"
            onClick={() => onSelectAll(!allSelected)}
            style={{
              background: "transparent",
              border: "none",
              cursor: "pointer",
              color: "white",
              fontSize: "20px",
              display: "flex",
              alignItems: "center",
              gap: "6px",
            }}
          >
            <span>Select All</span>
            <i
              className={`fa-solid ${allSelected ? "fa-toggle-on" : "fa-toggle-off"
                }`}
            ></i>
          </button>

          <button className="selection-bar-done-btn" onClick={onClear}>
            <i className="fa-solid fa-check"></i> Done
          </button>
        </div>
      </header>

      {showConfirm && (
        <ConfirmDialog
          message={`Are you sure you want to delete ${selectedCount} photo(s)?`}
          onConfirm={handleConfirmDelete}
          onCancel={() => setShowConfirm(false)}
        />
      )}

      {showFilters && (
        <FilterDialog
          photos={photos}
          selectedPhotos={selectedPhotos}
          onApply={handleApplyFilter}
          onCancel={() => setShowFilters(false)}
        />
      )}
    </>
  );
}

export default SelectionBar;